import React, { useEffect } from 'react'
import { injectIntl } from "react-intl";
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { avatar, men1, men2, men3, women1, women2, women3, call, video, office, whatsapp } from "../../../utils/images";
import { activeAppointmentRequest, getUpcommingAppointmentRequest } from '../../../store/appointments/actions';
import moment from 'moment';
import './home.scss';

function NextAppointment({ intl: { messages } }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { upcomingAppointment } = useSelector((state) => state.appointments);

  useEffect(() => {
    dispatch(getUpcommingAppointmentRequest())
  }, [dispatch])

  const mens = [men1, men2, men3];
  const womens = [women1, women2, women3];

  // console.log(moment().diff(moment(upcomingAppointment?.start_date), 'minutes'))
  
  return (
    <div className='next_container' >
        <h3>{upcomingAppointment && moment().isBetween(moment(upcomingAppointment?.start_date), moment(upcomingAppointment?.end_date)) ? messages.appointments.current : messages.appointments.next}</h3>
        {
          !upcomingAppointment ? <div className='no_next'>{messages.appointments.no_next}</div> :
          (
            <div className='next_app_container'>
              <div className="next_img">
                  <img src={upcomingAppointment?.patient_gender_type 
                        ? upcomingAppointment?.patient_gender_type === 1 ? mens[Math.floor(Math.random() * mens.length)] : upcomingAppointment?.patient_gender_type === 2 ? womens[Math.floor(Math.random() * womens.length)] : avatar
                        : avatar} alt="avatar img" />
              </div>
              <div className='next_title'>{upcomingAppointment?.patient_name}</div>
              <div className='next_date'>{moment(upcomingAppointment?.start_date).format("dddd,\xa0 DD MMMM YYYY, h:mm a")}</div>
              <div className='types_container'>
                <div className='next_type'>
                    <img src={parseInt(upcomingAppointment?.type) === 1 ? whatsapp : parseInt(upcomingAppointment?.type) === 2 ? video : parseInt(upcomingAppointment?.type) === 3 ? call : office} alt='TypeIcon' />
                    <div>
                      <span>{upcomingAppointment?.type_name}</span>
                      <span style={{ display: 'block', color: '#999', fontSize: '12px' }}>{upcomingAppointment?.purpose_name}</span>
                    </div>
                    
                </div>
                <button disabled={!moment().isBetween(moment(upcomingAppointment?.start_date).subtract(5, "minutes"), moment(upcomingAppointment?.end_date))}
                        onClick={() => upcomingAppointment?.status === 1 ? dispatch(activeAppointmentRequest(upcomingAppointment?.id, history)) : history.push(`/appointment/${upcomingAppointment?.id}`)} 
                        className='app_btn'>
                          {messages.appointments.start_app}
                </button>
              </div>
            </div>
          )
        }
    </div>
  )
}

export default injectIntl(NextAppointment)